var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-data-table',{ref:"userTable",attrs:{"pageUnit":_vm.pageUnit_,"totalSize":_vm.totalSize_,"paging":"","columns":_vm.columns,"rows":_vm.userList,"stripe":false,"selection":false,"index":"","height":"50vh"},on:{"changedPage":_vm.changedPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }